function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    id: "bracket",
    fill: "#7199de",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6 1.006c-.22 0-.638-.021-1.064.096a1.375 1.375 0 0 0-.633.35c-.192.192-.317.49-.317.796v3.75c0-.071-.003.01-.072.113-.069.106-.18.246-.297.383-.117.137-.242.275-.35.412a1.727 1.727 0 0 0-.15.217c-.047.082-.11.172-.11.367 0 .198.073.302.126.383.053.081.106.142.162.203.111.122.232.239.346.36.226.24.361.488.361.562v3.775c0 .334.156.65.37.838.212.19.453.277.675.328.443.104.896.067.953.067v-1c-.186 0-.481.014-.727-.043a.633.633 0 0 1-.24-.102c-.03-.026-.031-.01-.031-.09V8.998c0-.58-.363-.96-.633-1.248-.108-.115-.194-.201-.27-.28.076-.091.169-.2.278-.327.127-.149.262-.308.377-.485.115-.176.232-.366.232-.66V2.246c0-.084.007-.073.026-.092a.465.465 0 0 1 .187-.088c.214-.058.552-.06.801-.06v-1zm3.975.002v.998c.249 0 .587.001.8.062a.465.465 0 0 1 .188.088c.019.02.025.01.025.092V6c0 .578.367.93.635 1.219.102.11.182.192.256.271-.075.073-.152.146-.254.25-.278.284-.652.671-.652 1.26v3.773c0 .081-.002.063-.032.09a.636.636 0 0 1-.24.102c-.245.057-.54.043-.726.043v1c.056 0 .51.034.953-.069.221-.052.462-.137.676-.326.213-.189.369-.506.369-.84V9c0-.087.134-.324.365-.559.115-.117.24-.23.353-.35.058-.06.113-.12.168-.2.056-.081.131-.19.131-.391 0-.199-.069-.298-.12-.379a1.648 1.648 0 0 0-.161-.209c-.112-.126-.237-.248-.354-.373A2.113 2.113 0 0 1 11.988 6V2.248c0-.307-.124-.604-.316-.797a1.373 1.373 0 0 0-.633-.347c-.426-.117-.845-.096-1.064-.096z",
    color: "#000",
    fontFamily: "sans-serif",
    fontWeight: 400,
    overflow: "visible",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      blockProgression: "tb",
      whiteSpace: "normal",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.c680883e5992a5c0d6007c982aefabff.svg";
export { ForwardRef as ReactComponent };